import { Youtube as _Youtube } from '@tiptap/extension-youtube'

export interface YoutubeOptions {
  addPasteHandler: boolean
  allowFullscreen: boolean
  autoplay: boolean
  ccLanguage?: string
  ccLoadPolicy?: boolean
  controls: boolean
  disableKBcontrols: boolean
  enableIFrameApi: boolean
  endTime: number
  height?: number
  interfaceLanguage?: string
  ivLoadPolicy: number
  loop: boolean
  modestBranding: boolean
  HTMLAttributes: Record<string, any>
  inline: boolean
  nocookie: boolean
  origin: string
  playlist: string
  progressBarColor?: string
  width?: number
}

export const Youtube = _Youtube.extend<YoutubeOptions>({
  addOptions() {
    return {
      addPasteHandler: true,
      allowFullscreen: true,
      autoplay: false,
      ccLanguage: undefined,
      ccLoadPolicy: undefined,
      controls: true,
      disableKBcontrols: false,
      enableIFrameApi: false,
      endTime: 0,
      height: undefined,
      interfaceLanguage: undefined,
      ivLoadPolicy: 0,
      loop: false,
      modestBranding: false,
      HTMLAttributes: {},
      inline: false,
      nocookie: false,
      origin: '',
      playlist: '',
      progressBarColor: undefined,
      width: undefined,
    }
  },
})
